import { render, staticRenderFns } from "./addPremiumModal.vue?vue&type=template&id=524111ac&scoped=true"
import script from "./addPremiumModal.vue?vue&type=script&lang=js"
export * from "./addPremiumModal.vue?vue&type=script&lang=js"
import style0 from "./addPremiumModal.vue?vue&type=style&index=0&id=524111ac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524111ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('524111ac')) {
      api.createRecord('524111ac', component.options)
    } else {
      api.reload('524111ac', component.options)
    }
    module.hot.accept("./addPremiumModal.vue?vue&type=template&id=524111ac&scoped=true", function () {
      api.rerender('524111ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/insuranceManage/mainFrom/addPremiumModal.vue"
export default component.exports